import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { AiGatewayForm } from '../Forms/AiGatewayForm'
import { columns } from './OrganisationAiGatewaysTable/organisationAiGatewaysTableColumns'

export function OrganisationAiGatewaysPage() {
  return (
    <>
      <SubscriptionsBreadcrumb title="AI Gateways" />
      <QueryErrorBoundary errorMessage="Failed to fetch AI Gateways">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <OrganisationAiGatewaysPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function OrganisationAiGatewaysPanelContent() {
  const { id: orgId } = useCurrentOrganisation()
  const { getAiGatewayApiListGateways } = useRestClient()

  const { data: gateways } = getAiGatewayApiListGateways.useSuspenseQuery({
    query: { orgId },
  })

  const invalidate = () =>
    getAiGatewayApiListGateways.invalidateQueries({
      parameters: { query: { orgId } },
    })

  return (
    <TablePageContainer>
      <DataTable
        columns={columns}
        data={gateways ?? []}
        action={
          <AiGatewayForm
            sheetTitle="Add AI Gateway"
            sheetDescription="Create an org-scoped AI Gateway linked to an LLM provider."
            onSubmit={invalidate}
            sheetTrigger={
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add gateway
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
